import { render, staticRenderFns } from "./FactForm.vue?vue&type=template&id=40779fc7&scoped=true&"
import script from "./FactForm.vue?vue&type=script&lang=js&"
export * from "./FactForm.vue?vue&type=script&lang=js&"
import style0 from "./FactForm.vue?vue&type=style&index=0&id=40779fc7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40779fc7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCheckbox,VTextarea})
